export default __webpack_public_path__ + "static/media/ko.37e1cc5a.md";